import { useState } from "react";

import BasePopover from "../Popover/BasePopover";
import { DropdownMenuProps } from "./types";

import "./styles.css";

const DropdownMenu = ({
  children,
  title,
  content,
  ...props
}: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (newIsOpen: boolean) => {
    setIsOpen(newIsOpen);
    props.onOpenChange?.(newIsOpen);
  };

  return (
    <BasePopover
      content={<div onClick={() => handleOpenChange(false)}>{content}</div>}
      title={title}
      trigger="click"
      rootClassName="dropdown-menu-popover"
      {...props}
      open={isOpen}
      onOpenChange={handleOpenChange}
    >
      {children}
    </BasePopover>
  );
};

export default DropdownMenu;
